export interface JesprBike {
  name: string;
  category: JesprBikeCategory;
}

export enum JesprBikeCategory {
  Indoor = "INDOOR",
}
